<!--suppress ALL -->
<template>
	<v-select
		v-model="model"
		:items="options"
		label="בחר"
		item-text="subject"
		item-value="id"
	/>
</template>

<script>
import ProjectModule from "src/store/modules/Project.module";
import SelectMixin from "src/mixins/SelectMixin";

export default {
	name: "ProjectsSelect",
	components: {},
	mixins: [new SelectMixin(ProjectModule, "projects")],
	props: { type: [Number, Object, String], value: { type: [Number, Object, String], default: null } },
};
</script>
